import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=1e021cf7&"
import script from "./Favourite.vue?vue&type=script&lang=js&"
export * from "./Favourite.vue?vue&type=script&lang=js&"
import style0 from "./Favourite.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports